module.exports = __webpack_public_path__ + "img/202407_07.d13948be.jpg";